export default {
    namespaced: true,
    state: {
        refMarcacoesFuncionario: null,
    },
    getters: {
        getRefMarcacoesFuncionario(state) {
            return state.refMarcacoesFuncionario;
        },              
    },
    mutations: {        
        setRefMarcacoesFuncionario(state, dados) {
            return state.refMarcacoesFuncionario = dados;
        }, 
    },
    actions: {        
        inluirRefMarcacoesFuncionario(context, dados) {                  
            context.commit('setRefMarcacoesFuncionario', dados);  
        },
        limparRefMarcacoesFuncionario(context) {            
            context.commit('setRefMarcacoesFuncionario', null);  
        }        
    }
}